import s from './style.module.scss';

const GroupTitle = (props) => {
    const { children = '', ...otherParams } = props;
    return (
        <div className={s['group-title']} {...otherParams}>
            {children}
        </div>
    );
};

export default GroupTitle;
